import { render, staticRenderFns } from "./ChoiceCategories.vue?vue&type=template&id=07a5fe18&scoped=true"
import script from "./ChoiceCategories.vue?vue&type=script&lang=js"
export * from "./ChoiceCategories.vue?vue&type=script&lang=js"
import style0 from "./ChoiceCategories.vue?vue&type=style&index=0&id=07a5fe18&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a5fe18",
  null
  
)

export default component.exports